import type { ErrorBoundaryContextProps } from 'components/common-form/builder/form/errorBoundary';
import { FC } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { useIntl } from 'react-intl';

import { TechnicalDetails } from './ResetButton';

export const BlockFallback: FC<FallbackProps & ErrorBoundaryContextProps> = ({ error, resetErrorBoundary }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="alert alert-discreet-danger">
      <em className="icon icon-md pe-2">error</em>
      {formatMessage({ id: 'errorSomethingWentWrong' })}
      <TechnicalDetails
        errorMessage={(error as Error)?.message}
        stack={(error as Error)?.stack}
        reset={resetErrorBoundary}
      />
    </div>
  );
};
